import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=56ce8dba&scoped=true"
import script from "./group-list.vue?vue&type=script&lang=js"
export * from "./group-list.vue?vue&type=script&lang=js"
import style0 from "./group-list.vue?vue&type=style&index=0&id=56ce8dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce8dba",
  null
  
)

export default component.exports